<template>
	<AppCard>
		<div class="[&_h4]:mt-4">
			<p>
				Voor een hypotheekberekening en hypotheekaanvraag hebben we documenten
				nodig met betrekking tot het inkomen. Hieronder zie je welke documenten
				je moet uploaden in jouw situatie:
			</p>

			<h4>Je bent in loondienst</h4>
			<ol>
				<li>Recente loonstrook van aanvrager(s)</li>
				<li>
					<a
						href="https://www.hellohypotheek.nl/wp-content/uploads/2022/04/instructie-downloaden-verzekeringsbericht-jan-2022.pdf"
						target="_blank"
						rel="noopener noreferrer"
						>Verzekeringsbericht UWV</a
					>
					van aanvrager(s)
				</li>
			</ol>

			<h4>Je bent ondernemer</h4>
			<ol>
				<li>Aangiften inkomstenbelasting van de afgelopen drie jaar</li>
				<li>
					Als je DGA bent, ook graag de jaarrekeningen van je vennootschap(pen)
					van de afgelopen drie jaar
				</li>
			</ol>

			<h4>Je bent met pensioen óf je bent ouder dan 56 jaar</h4>
			<ol>
				<li>
					Dan graag het digitale
					<a
						href="https://www.mijnpensioenoverzicht.nl/"
						target="_blank"
						rel="noopener noreferrer"
						>pensioenoverzicht</a
					>
					van de aanvrager(s)
				</li>
			</ol>
		</div>
	</AppCard>
</template>
